import { TinyColor } from '@ctrl/tinycolor';
import type { BdColorFactoryType } from './color-factory';
import { BdColorFactory } from './color-factory';
import { BdArrayUtil } from '../util';

export interface BdColorRange {
  from: number;
  to: number;
  color: TinyColor;
}

export class BdColorCustomFactory extends BdColorFactory {
  public type: BdColorFactoryType = 'custom';

  public static fromObject(
    obj: BdColorCustomFactoryOptions,
  ): BdColorCustomFactory {
    let ranges: BdColorRange[] = [];
    if (obj.ranges) {
      ranges = obj.ranges.map((it) => ({
        ...it,
        color: new TinyColor(it.color),
      }));
    }
    return new BdColorCustomFactory(ranges);
  }

  constructor(public ranges: BdColorRange[] = []) {
    super();
  }

  public getColorForValue(value: number): TinyColor | null {
    return (
      this.ranges.find((range) => range.from <= value && value < range.to)
        ?.color ?? null
    );
  }

  public clone(): BdColorCustomFactory {
    return new BdColorCustomFactory(
      this.ranges.map((it) => ({
        ...it,
        color: it.color.clone(),
      })),
    );
  }

  equals(other: BdColorFactory): boolean {
    switch (other.type) {
      case 'custom': {
        return BdArrayUtil.equals(
          this.ranges,
          (other as BdColorCustomFactory).ranges,
          (a, b) =>
            a.from === b.from && a.to === b.to && a.color.equals(b.color),
        );
      }
      default: {
        return false;
      }
    }
  }

  toJSON(): BdColorCustomFactoryOptions {
    return {
      type: this.type,
      ranges: this.ranges.map((it) => ({
        ...it,
        color: it.color.toString(),
      })),
    };
  }
}

export interface BdColorCustomFactoryOptions {
  type: BdColorFactoryType;
  ranges: { from: number; to: number; color: string }[];
}
